import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.sl';

import initPromo from './promo';
import initPhotoSwipe  from './photoswipe';

window.$ = $;

$(document).ready(function() {

  if ($("#promo").length) {
    initPromo($("#promo"));
  }

  $('#id_c_field').val('5').parents('.form-group').hide();
  $('.dateinput').datepicker({
    format: 'dd.mm.yyyy',
    language: window.LANGUAGE_CODE || 'sl',
  });

  initPhotoSwipe($('.gallery'), $('.pswp')[0]);

  $('.actual-blocks .box[data-url]').on(
    'click',
    e => {
      e.preventDefault();
      window.location = $(e.target).closest('.box').data('url');
    }
  );
});



// WEBPACK FOOTER //
// ./website/static_media/assets/js/main.js